import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  header: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: theme.zIndex.appBar,
    backgroundColor: "#FFFFFF",
    borderBottom: "3px solid transparent",
    borderImage: "linear-gradient(90deg, #0ADBDB, #2BE65E) 1",
  },
  inner: {
    width: "100%",
    maxWidth: 760,
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(1.5, 3),
    boxSizing: "border-box",
  },
  logo: {
    height: 42,
    width: "auto",
  },
  meta: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    textAlign: "right",
    // Ocupa el espacio libre y se deja achicar: así el detalle del espacio se
    // recorta con puntos suspensivos en vez de estirar el encabezado.
    flex: 1,
    minWidth: 0,
  },
  logoutButton: {
    marginLeft: theme.spacing(1),
    color: "#5B5D66",
  },
  timestamp: {
    fontWeight: 800,
    color: "#003350",
    lineHeight: 1.2,
    textAlign: "right",
  },
  subtitle: {
    fontSize: "0.8rem",
    color: "#5B5D66",
    lineHeight: 1.3,
    textAlign: "right",
    // Con el ancho del contenedor el recorte cae al final y el nombre se lee entero.
    width: "100%",
  },
}));

export default useStyles;
